import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./en";
import zh from "./zh";
import elementLocale from "element-ui/lib/locale";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("locale") || "zh", // 默认语言
  messages: { en, zh },
});
elementLocale.i18n((key, value) => i18n.t(key, value));
export default i18n;
